import SearchBar from 'components/SearchBar/SearchBar';
import BaseMultiDropdown from 'features/components/BaseMultiDropdown';
import { Accordion } from 'react-bootstrap';
import AudioActionRow from './AudioActionRow';

export default function ManageDeviceAssociationsSection({
  sectionCardClass,
  isCompactLayout,
  manageDeviceSearchValue,
  setManageDeviceSearchValue,
  filteredManageDeviceOptions,
  clearManagedAudiosForVisibleDevices,
  groupedManageDeviceOptions,
  managedDeviceAudioSelections,
  getEffectiveManagedAudioIdsForDevice,
  getSelectedAudioCountForDevice,
  getManagedAudiosForDevice,
  toggleManagedAudioForDevice,
  toEdit,
  editName,
  setEditName,
  onEdit,
  onResolveEdit,
  onCancelEdit,
  setToDelete,
  canEditDelete,
  updateAudioList,
}) {
  const renderManagedAudioRow = (device, audio, audioIndex) => (
    <AudioActionRow
      key={`manage-device-${device.value}-audio-${audio.id}`}
      audio={audio}
      index={audioIndex}
      compact={false}
      checked={getEffectiveManagedAudioIdsForDevice(device.value).includes(audio.id)}
      onToggle={() => toggleManagedAudioForDevice(device.value, audio.id)}
      toEdit={toEdit}
      editName={editName}
      onEditNameChange={setEditName}
      onEdit={onEdit}
      onResolveEdit={onResolveEdit}
      onCancelEdit={onCancelEdit}
      onDelete={setToDelete}
      canEditDelete={canEditDelete}
      updateAudioList={updateAudioList}
    />
  );

  return (
    <div className="d-flex flex-column flex-grow-1 min-h-0 gap-3">
      <div className={sectionCardClass}>
        <div className="d-flex align-items-center justify-content-between bg-primary px-3 py-2 border-bottom border-secondary">
          <span className="fw-semibold">Manage device associations</span>
        </div>
        <div
          className={`min-h-0 p-3 pt-2 ${
            isCompactLayout
              ? 'd-flex flex-column overflow-hidden'
              : 'd-flex flex-column flex-grow-1'
          }`}
          style={isCompactLayout ? { maxHeight: '18rem' } : undefined}
        >
          <SearchBar
            className="mb-2 flex-shrink-0 min-width-0"
            inputClassName="text-white"
            placeholder="Search devices"
            value={manageDeviceSearchValue}
            onChange={setManageDeviceSearchValue}
            includeClear
          />
          <BaseMultiDropdown
            groups={groupedManageDeviceOptions}
            showGroupHeaders={false}
            sectionsCollapsible={false}
            emptyMessage="No devices found."
            getDefaultActiveKeys={(group) => (group?.sections || []).map((section) => section.id)}
            containerClassName="d-flex flex-column gap-2 bg-primary rounded-3 border border-light border-opacity-25 p-2 flex-grow-1 min-h-0 overflow-y-auto overflow-x-hidden"
            sectionClassName="border border-light border-opacity-25 rounded-2 overflow-hidden bg-primary"
            sectionBodyClassName="bg-primary-shadow p-2 pt-2"
            renderSectionHeader={(section) => (
              <div className="d-flex w-100 align-items-center gap-2 fw-semibold">
                <span className="text-break fs-6">{section?.label || 'Unnamed Group'}</span>
              </div>
            )}
            renderSectionContent={(section) => (
              <Accordion
                alwaysOpen
                defaultActiveKey={section.items.map((device) => `manage-device-${device.value}`)}
                className="w-100"
              >
                {section.items.map((device, deviceIndex) => {
                  const selectedAudioCount = getSelectedAudioCountForDevice(device.value);
                  const availableAudios = getManagedAudiosForDevice(device.value);

                  return (
                    <Accordion.Item
                      eventKey={`manage-device-${device.value}`}
                      key={`manage-device-${device.value}`}
                      className={`border border-light border-opacity-25 rounded-2 overflow-hidden bg-transparent ${
                        deviceIndex < section.items.length - 1 ? 'mb-2' : ''
                      }`}
                    >
                      <Accordion.Header>
                        <div className="d-flex w-100 align-items-center justify-content-between gap-2 pe-2 fw-semibold">
                          <span className="text-truncate" style={{ minWidth: 0 }}>
                            {device.label || 'Unnamed Device'}
                          </span>
                          <span className="d-inline-flex align-items-center justify-content-center px-2 py-0 rounded-pill border border-light border-opacity-25 bg-dark bg-opacity-25 small text-nowrap">
                            {selectedAudioCount} files
                          </span>
                        </div>
                      </Accordion.Header>
                      <Accordion.Body className="bg-primary-shadow p-0">
                        {availableAudios.length === 0 ? (
                          <div className="px-3 py-3 text-secondary">No files available.</div>
                        ) : (
                          availableAudios.map((audio, audioIndex) =>
                            renderManagedAudioRow(device, audio, audioIndex),
                          )
                        )}
                      </Accordion.Body>
                    </Accordion.Item>
                  );
                })}
              </Accordion>
            )}
          />
        </div>
      </div>
    </div>
  );
}
